import { fetchURL, PrefInfo, scrapeArea, summaryArea, WestArea } from "src/module/fetch";
import style from "./area.css";

const kzs = window.kzs;
import $ from "jquery";
// const $ = kzs.$;

/* デバイス種別 */
export type Device = "pc" | "sp";

export type Config = {
  device: Device;
  link: string;
};

/**
 * 別ページにある故障状況を取得し、エリア毎にサマリーしてトップページに表示させる
 *
 * @param device デバイス種別
 * @param url 故障状況ページのURL
 */
export const inspectBreakDown = (config: Config, url: string): void => {
  fetchURL(url, (doc: Document) => {
    // 故障状況をエリア毎にサマリー
    const $prefs = $(doc).find("#prefs");
    const prefs = JSON.parse($prefs.val() as string);
    kzs.console.log(`prefs: `, prefs);
    const area = scrapeArea(prefs["prefs"]);
    kzs.console.log(`area: `, area);

    // サマリー結果を画面に埋め込み
    embed(config, url, area);
  });
};

const embed = (config: Config, url: string, areas: WestArea<PrefInfo>): void => {
  // デバイスに応じたスタイルシート適用
  // config.device === "pc" ? pcStyles.use() : spStyles.use();
  style.use();

  const noneImg = `<img src="https://www.ntt-west.co.jp/img/icon_legend_circle.svg" class="kzImg" alt="まる" />`;
  const partialImg = `<img src="https://www.ntt-west.co.jp/img/icon_legend_triangle.svg" class="kzImg" alt="さんかく"/>`;
  const allImg = `<img src="https://www.ntt-west.co.jp/img/icon_legend_cross.svg" class="kzImg" alt="ばつ" />`;

  const guide = `
    <section class="kzGuide">
      <p class="kzTitle">凡例</p>
      <ul class="kzItems">
        <li class="kzItem kzNone">
          ${noneImg}
          <span>正常</span>
        </li>
        <li class="kzItem kzPartial">
          ${partialImg}
          <span>一部エリアにてご利用できない状況等が発生</span>
        </li>
        <li class="kzItem kzAll">
          ${allImg}
          <span>全エリアにてご利用できない状況等が発生</span>
        </li>
      </ul>
      <p class="kzGuideLink">凡例の詳細は<a href="${config.link}" target="_blank">こちら</a></p>
    </section>
  `;

  const $dom = $(`
    <div class="kzBreakDownWrapper">
      <div class="kzBreakDownInfo">
        <div class="kzHeader">
          <p class="kzTitle">通信サービス状況</p>
        </div>
        <ul class="kzBreakDownList">
          <li class="kinki">
            <a href="${url}">
              <p class="kzTitle">関西</p>
              <p class="kzResult"></p>
            </a>
          </li>
          <li class="tokai">
            <a href="${url}">
              <p class="kzTitle">東海</p>
              <p class="kzResult"></p>
            </a>
          </li>
          <li class="hokuriku">
            <a href="${url}">
              <p class="kzTitle">北陸</p>
              <p class="kzResult"></p>
            </a>
          </li>
          <li class="cyugoku">
            <a href="${url}">
              <p class="kzTitle">中国</p>
              <p class="kzResult"></p>
            </a>
          </li>
          <li class="shikoku">
            <a href="${url}">
              <p class="kzTitle">四国</p>
              <p class="kzResult"></p>
            </a>
          </li>
          <li class="kyusyu">
            <a href="${url}">
              <p class="kzTitle">九州・沖縄</p>
              <p class="kzResult"></p>
            </a>
          </li>
        </ul>
        ${guide}
      </div>
    </div>
    `);

  const none = `
    <div class="kzNone">${noneImg}</div>
  `;
  const partial = `
    <div class="kzPartial">${partialImg}</div>
  `;
  const all = `
    <div class="kzAll">${allImg}</div>
  `;
  const table = {
    none: none,
    partial: partial,
    all: all,
  };

  // 北陸
  append($dom, areas.hokuriku, "hokuriku", table);

  // 東海
  append($dom, areas.tokai, "tokai", table);

  // 近畿
  append($dom, areas.kinki, "kinki", table);

  // 中国
  append($dom, areas.cyugoku, "cyugoku", table);

  // 四国
  append($dom, areas.shikoku, "shikoku", table);

  // 九州
  append($dom, areas.kyusyu, "kyusyu", table);

  // 実ページに挿入
  if (isNormalPage()) {
    // 通常ページの場合
    $dom.insertBefore($(".loc-visual"));
  } else {
    // 故障ページの場合
    $dom.insertBefore($(".l-sec--dengon"));
  }
};

/**
 * 指定された$dom上に対象エリアの故障状況を挿入する
 * （実DOMには反映せず、jQueryオブジェクトの更新のみ行う）
 *
 * @param $dom 対象DOM
 * @param area 対象エリア
 * @param areaName 画面に表示するエリアメイ
 * @param table 故障ステータス毎のDOM
 */
const append = (
  $dom: JQuery<HTMLElement>,
  area: Record<string, PrefInfo>,
  areaName: string,
  table: Record<string, string>
) => {
  // 故障状況をサマリー
  const summaried = summaryArea(area);
  kzs.console.log(`${areaName}: `, summaried);

  // 挿入位置を決定
  const $target = $(table[summaried]);

  // 挿入
  $dom
    .find(`.${areaName}`)
    .addClass($target.attr("class") || "")
    .find(`.kzResult`)
    .append($target);
};

const isNormalPage = (): boolean => {
  return $(".l-sec--dengon").length == 0;
};
